import { render, staticRenderFns } from "./FluxoCaixa.vue?vue&type=template&id=afb078f4&"
import script from "./FluxoCaixa.vue?vue&type=script&lang=js&"
export * from "./FluxoCaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports